import ActionButton from 'components/ActionButton';
import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';

const WEEK_DAYS: any = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
  
function WeekZipcodePicker({ dataFromProps, text, updateLoading, onUpdate }:
  { dataFromProps: any; text: string; updateLoading: boolean; onUpdate: any }) {
  const [textareaValues, setTextareaValues] = useState<any>([]);
  const [selectedDays, setSelectedDays] = useState<any>([]);


  useEffect(() => {
    initializeDataFromProps();
  }, [dataFromProps]);

  const initializeDataFromProps =()=>{
    const initialValues = Array(WEEK_DAYS.length).fill('');
    setSelectedDays([]);
    if (dataFromProps && typeof dataFromProps === 'object') {
      Object.entries(dataFromProps).forEach(([dayIndex, values]: any) => {
        const index = parseInt(dayIndex, 10);
        if (index >= 0 && index < WEEK_DAYS.length) {
          initialValues[index] = values.join(', ');
          setSelectedDays((prevSelectedDays: any) => [...prevSelectedDays, index]);
        }
      });
    }
    setTextareaValues(initialValues);
  };

  const handleZipCodeChange = (dayIndex: string | number, value: string) => {
    setTextareaValues((prevValues: any) => {
      const updatedValues = [...prevValues];
      updatedValues[dayIndex] = value;
      return updatedValues;
    });
  };

  const handleCheckBoxChange = (dayIndex: string | number, isChecked: boolean) => {
    if (isChecked) {
      setSelectedDays((prevSelectedDays: any) => [...prevSelectedDays, dayIndex]);
    } else {
      setSelectedDays((prevSelectedDays: any[]) => prevSelectedDays.filter((day: any) => day !== dayIndex));
      // Clear the textarea value when the checkbox is unchecked
      setTextareaValues((prevValues: any) => {
        const updatedValues = [...prevValues];
        delete updatedValues[dayIndex];
        return updatedValues;
      });
    }
  };

  const handleUpdateZipcodes = () => {
    const dataToUpdate = {};
    selectedDays.map((day: string | number) => {
      dataToUpdate[day] = textareaValues[day]?.split(',')?.map((value: string) => value.trim());
    });

    onUpdate && onUpdate({ excludeZipcodesForDay: dataToUpdate }, 'Excluded Zipcodes for Days updated successfully');
  };

  const getCheckBoxAndZipcodeInputs = () =>{
    return (
      <div className="days-checkboxes mt-2">
        {WEEK_DAYS.map((value: boolean | React.ReactChild | React.ReactFragment | React.ReactPortal | null | undefined, i: string | number ) => (
          <div key={i} className={styles['day-group']}>
            <input
              type='checkbox'
              checked={selectedDays.includes(i) || false}
              onChange={(e) => handleCheckBoxChange(i, e.target.checked)}
            />
            <div style={{ minWidth: '80px' }}>{value}</div>
            {(selectedDays.includes(i)) && (
              <textarea
                rows={2}
                className="ml-3 form-control"
                value={textareaValues[i]}
                onChange={(e) => handleZipCodeChange(i, e.target.value)}
              />
            )}
          </div>
        ))}
      </div>
    );
  };

  const getHeader=()=>(
    <div className='mb-3'>{text}
      <span className='text-muted small mb-3'>( Enter comma seperated zipcodes. )</span>
    </div>
  );

  return (
    <div>
      {getHeader()}
      {getCheckBoxAndZipcodeInputs()}
      <ActionButton
        text={'Update Excluded Zipcodes for Delivery'}
        active={!updateLoading}
        isLoading={updateLoading}
        onClick={handleUpdateZipcodes}
      />
    </div>
  );
}

export default WeekZipcodePicker;